package flagpack.icons.small

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Saudi Arabia Flag (16x12dp)
 *
 * - ISO Alpha-2: SA
 * - ISO Alpha-3: SAU
 * - ISO Numeric: 682
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Small.SaudiArabia: ImageVector by lazy {
    ImageVector.Builder(
        name = "Saudi Arabia:SA:SAU:682:Small",
        defaultWidth = 16.dp,
        defaultHeight = 12.dp,
        viewportWidth = 16f,
        viewportHeight = 12f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
            path(fill = SolidColor(Color(0xFF005430))) {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
            path(
                stroke = SolidColor(Color.White),
                strokeLineWidth = 0.5f
            ) {
                moveTo(3.491f, 2.288f)
                curveTo(3.491f, 2.288f, 3.746f, 3.452f, 3.491f, 3.229f)
                curveTo(3.236f, 3.006f, 2.668f, 3.857f, 3.261f, 3.543f)
                curveTo(3.853f, 3.229f, 3.958f, 2.904f, 3.958f, 3.543f)
                curveTo(3.958f, 4.182f, 4.241f, 3.857f, 3.751f, 4.332f)
                curveTo(3.261f, 4.807f, 5.469f, 4.815f, 4.48f, 5.112f)
                curveTo(3.491f, 5.41f, 3.022f, 6.044f, 3.751f, 5.811f)
                curveTo(4.48f, 5.578f, 5.653f, 4.59f, 5.347f, 4.332f)
                curveTo(5.041f, 4.075f, 5.191f, 4.127f, 5.191f, 3.543f)
                curveTo(5.191f, 2.959f, 4.997f, 2.808f, 4.743f, 2.657f)
                curveTo(4.49f, 2.506f, 5.73f, 3.678f, 6.144f, 2.983f)
                curveTo(6.558f, 2.288f, 6.508f, 2.736f, 6.808f, 2.983f)
                curveTo(7.107f, 3.229f, 7.573f, 3.526f, 7.573f, 2.983f)
                curveTo(7.573f, 2.439f, 8.188f, 1.39f, 8.188f, 2.467f)
                curveTo(8.188f, 3.543f, 8.96f, 4.099f, 8.96f, 3.378f)
                curveTo(8.96f, 2.657f, 9.67f, 1.951f, 9.67f, 2.467f)
                curveTo(9.67f, 2.983f, 10.077f, 2.959f, 10.425f, 2.808f)
                curveTo(10.774f, 2.657f, 10.744f, 2.259f, 10.744f, 3.378f)
                curveTo(10.744f, 4.498f, 10.89f, 6.247f, 10.425f, 6.099f)
                curveTo(9.961f, 5.952f, 10.395f, 5.286f, 9.96f, 4.332f)
                curveTo(9.525f, 3.378f, 10.403f, 3.375f, 9.495f, 4.593f)
                curveTo(8.587f, 5.811f, 8.732f, 5.632f, 8.46f, 5.112f)
                curveTo(8.188f, 4.593f, 9.346f, 4.072f, 8.46f, 4.332f)
                curveTo(7.573f, 4.593f, 8.055f, 6.051f, 7.814f, 5.582f)
                curveTo(7.573f, 5.112f, 6.958f, 2.618f, 6.883f, 3.865f)
                curveTo(6.808f, 5.112f, 7.119f, 5.811f, 6.46f, 5.811f)
                curveTo(5.8f, 5.811f, 5.243f, 5.861f, 5.693f, 5.582f)
                curveTo(6.144f, 5.303f, 6.144f, 4.332f, 6.144f, 4.332f)
            }
            path(
                fill = SolidColor(Color.White),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6.967f, 7.928f)
                curveTo(6.56f, 7.977f, 4.506f, 7.969f, 3.892f, 7.821f)
                curveTo(3.754f, 7.792f, 3.833f, 8.419f, 3.922f, 8.563f)
                curveTo(4.011f, 8.707f, 4.709f, 8.851f, 4.953f, 8.885f)
                curveTo(5.162f, 8.913f, 5.967f, 8.868f, 6.804f, 8.822f)
                curveTo(6.942f, 8.814f, 7.082f, 8.806f, 7.219f, 8.799f)
                curveTo(7.952f, 8.759f, 9.023f, 8.828f, 9.582f, 8.865f)
                curveTo(9.763f, 8.876f, 9.891f, 8.885f, 9.937f, 8.885f)
                curveTo(10.108f, 8.885f, 10.095f, 8.943f, 10.069f, 9.059f)
                curveTo(10.067f, 9.069f, 10.065f, 9.079f, 10.062f, 9.09f)
                curveTo(10.033f, 9.228f, 10.187f, 9.523f, 10.255f, 9.55f)
                curveTo(10.323f, 9.578f, 10.827f, 9.55f, 11.102f, 9.444f)
                curveTo(11.258f, 9.384f, 11.277f, 9.392f, 11.317f, 9.411f)
                curveTo(11.348f, 9.425f, 11.392f, 9.444f, 11.517f, 9.444f)
                curveTo(11.706f, 9.444f, 11.716f, 9.174f, 11.723f, 8.983f)
                curveTo(11.727f, 8.879f, 11.729f, 8.799f, 11.76f, 8.799f)
                curveTo(11.795f, 8.799f, 11.841f, 8.901f, 11.884f, 8.996f)
                curveTo(11.95f, 9.142f, 12.009f, 9.272f, 12.009f, 9.003f)
                curveTo(12.009f, 8.556f, 11.484f, 7.971f, 11.312f, 8.018f)
                curveTo(11.191f, 8.051f, 10.993f, 8.015f, 10.859f, 7.99f)
                curveTo(10.801f, 7.98f, 10.755f, 7.971f, 10.732f, 7.971f)
                curveTo(10.699f, 7.971f, 10.709f, 7.963f, 10.731f, 7.945f)
                curveTo(10.76f, 7.922f, 10.81f, 7.881f, 10.81f, 7.821f)
                curveTo(10.81f, 7.713f, 10.708f, 7.698f, 10.623f, 7.698f)
                curveTo(10.538f, 7.698f, 10.493f, 7.768f, 10.493f, 7.821f)
                curveTo(10.493f, 7.874f, 10.557f, 7.928f, 10.557f, 7.928f)
                curveTo(10.543f, 7.928f, 10.476f, 7.927f, 10.369f, 7.926f)
                curveTo(9.678f, 7.916f, 7.319f, 7.885f, 6.967f, 7.928f)
                close()
                moveTo(10.438f, 8.873f)
                curveTo(10.438f, 8.873f, 10.492f, 8.842f, 10.617f, 8.687f)
                curveTo(10.756f, 8.516f, 10.805f, 8.571f, 10.856f, 8.628f)
                curveTo(10.882f, 8.657f, 10.909f, 8.687f, 10.95f, 8.687f)
                curveTo(11.067f, 8.687f, 11.223f, 8.687f, 11.324f, 8.773f)
                curveTo(11.425f, 8.859f, 11.191f, 8.977f, 11.123f, 8.977f)
                curveTo(11.089f, 8.977f, 11.064f, 8.956f, 11.038f, 8.934f)
                curveTo(11.013f, 8.913f, 10.987f, 8.891f, 10.951f, 8.891f)
                curveTo(10.91f, 8.891f, 10.875f, 8.921f, 10.846f, 8.946f)
                curveTo(10.826f, 8.963f, 10.81f, 8.977f, 10.797f, 8.977f)
                curveTo(10.785f, 8.977f, 10.759f, 8.962f, 10.726f, 8.943f)
                curveTo(10.665f, 8.908f, 10.578f, 8.859f, 10.507f, 8.859f)
                curveTo(10.462f, 8.859f, 10.438f, 8.873f, 10.438f, 8.873f)
                close()
            }
            path(fill = SolidColor(Color.White)) {
                moveTo(3.892f, 7.821f)
                lineTo(3.903f, 7.772f)
                lineTo(3.902f, 7.772f)
                lineTo(3.892f, 7.821f)
                close()
                moveTo(6.967f, 7.928f)
                lineTo(6.973f, 7.977f)
                lineTo(6.967f, 7.928f)
                close()
                moveTo(3.922f, 8.563f)
                lineTo(3.964f, 8.537f)
                lineTo(3.922f, 8.563f)
                close()
                moveTo(4.953f, 8.885f)
                lineTo(4.96f, 8.835f)
                lineTo(4.953f, 8.885f)
                close()
                moveTo(6.804f, 8.822f)
                lineTo(6.801f, 8.772f)
                lineTo(6.804f, 8.822f)
                close()
                moveTo(7.219f, 8.799f)
                lineTo(7.222f, 8.848f)
                lineTo(7.219f, 8.799f)
                close()
                moveTo(9.582f, 8.865f)
                lineTo(9.579f, 8.914f)
                lineTo(9.582f, 8.865f)
                close()
                moveTo(10.069f, 9.059f)
                lineTo(10.118f, 9.07f)
                verticalLineTo(9.07f)
                lineTo(10.069f, 9.059f)
                close()
                moveTo(10.062f, 9.09f)
                lineTo(10.014f, 9.08f)
                verticalLineTo(9.08f)
                lineTo(10.062f, 9.09f)
                close()
                moveTo(11.102f, 9.444f)
                lineTo(11.12f, 9.491f)
                lineTo(11.102f, 9.444f)
                close()
                moveTo(11.317f, 9.411f)
                lineTo(11.338f, 9.365f)
                verticalLineTo(9.365f)
                lineTo(11.317f, 9.411f)
                close()
                moveTo(11.723f, 8.983f)
                lineTo(11.773f, 8.985f)
                verticalLineTo(8.985f)
                lineTo(11.723f, 8.983f)
                close()
                moveTo(11.884f, 8.996f)
                lineTo(11.929f, 8.976f)
                verticalLineTo(8.976f)
                lineTo(11.884f, 8.996f)
                close()
                moveTo(11.312f, 8.018f)
                lineTo(11.299f, 7.97f)
                verticalLineTo(7.97f)
                lineTo(11.312f, 8.018f)
                close()
                moveTo(10.859f, 7.99f)
                lineTo(10.85f, 8.039f)
                lineTo(10.859f, 7.99f)
                close()
                moveTo(10.731f, 7.945f)
                lineTo(10.7f, 7.906f)
                verticalLineTo(7.906f)
                lineTo(10.731f, 7.945f)
                close()
                moveTo(10.557f, 7.928f)
                verticalLineTo(7.978f)
                horizontalLineTo(10.693f)
                lineTo(10.589f, 7.89f)
                lineTo(10.557f, 7.928f)
                close()
                moveTo(10.369f, 7.926f)
                lineTo(10.369f, 7.976f)
                lineTo(10.369f, 7.926f)
                close()
                moveTo(10.617f, 8.687f)
                lineTo(10.656f, 8.719f)
                lineTo(10.617f, 8.687f)
                close()
                moveTo(10.438f, 8.873f)
                lineTo(10.481f, 8.848f)
                lineTo(10.481f, 8.848f)
                lineTo(10.438f, 8.873f)
                close()
                moveTo(10.856f, 8.628f)
                lineTo(10.819f, 8.661f)
                lineTo(10.819f, 8.661f)
                lineTo(10.856f, 8.628f)
                close()
                moveTo(11.324f, 8.773f)
                lineTo(11.356f, 8.735f)
                lineTo(11.324f, 8.773f)
                close()
                moveTo(11.038f, 8.934f)
                lineTo(11.006f, 8.973f)
                lineTo(11.038f, 8.934f)
                close()
                moveTo(10.846f, 8.946f)
                lineTo(10.878f, 8.984f)
                lineTo(10.846f, 8.946f)
                close()
                moveTo(10.726f, 8.943f)
                lineTo(10.75f, 8.9f)
                lineTo(10.726f, 8.943f)
                close()
                moveTo(10.507f, 8.859f)
                verticalLineTo(8.809f)
                verticalLineTo(8.859f)
                close()
                moveTo(3.88f, 7.869f)
                curveTo(4.193f, 7.945f, 4.866f, 7.984f, 5.506f, 7.998f)
                curveTo(6.147f, 8.013f, 6.765f, 8.003f, 6.973f, 7.977f)
                lineTo(6.961f, 7.878f)
                curveTo(6.762f, 7.902f, 6.15f, 7.913f, 5.508f, 7.898f)
                curveTo(4.866f, 7.884f, 4.204f, 7.845f, 3.903f, 7.772f)
                lineTo(3.88f, 7.869f)
                close()
                moveTo(3.964f, 8.537f)
                curveTo(3.947f, 8.508f, 3.927f, 8.449f, 3.909f, 8.371f)
                curveTo(3.892f, 8.295f, 3.878f, 8.206f, 3.872f, 8.123f)
                curveTo(3.865f, 8.039f, 3.866f, 7.964f, 3.875f, 7.913f)
                curveTo(3.88f, 7.887f, 3.886f, 7.873f, 3.89f, 7.868f)
                curveTo(3.892f, 7.866f, 3.891f, 7.867f, 3.888f, 7.868f)
                curveTo(3.885f, 7.87f, 3.882f, 7.87f, 3.881f, 7.869f)
                lineTo(3.902f, 7.772f)
                curveTo(3.884f, 7.768f, 3.866f, 7.769f, 3.848f, 7.777f)
                curveTo(3.832f, 7.784f, 3.819f, 7.796f, 3.81f, 7.808f)
                curveTo(3.792f, 7.832f, 3.783f, 7.864f, 3.777f, 7.895f)
                curveTo(3.765f, 7.958f, 3.765f, 8.044f, 3.772f, 8.131f)
                curveTo(3.779f, 8.219f, 3.793f, 8.312f, 3.811f, 8.393f)
                curveTo(3.829f, 8.472f, 3.852f, 8.545f, 3.879f, 8.589f)
                lineTo(3.964f, 8.537f)
                close()
                moveTo(4.96f, 8.835f)
                curveTo(4.84f, 8.819f, 4.607f, 8.775f, 4.392f, 8.717f)
                curveTo(4.285f, 8.688f, 4.184f, 8.656f, 4.106f, 8.623f)
                curveTo(4.066f, 8.607f, 4.033f, 8.59f, 4.008f, 8.574f)
                curveTo(3.983f, 8.558f, 3.97f, 8.545f, 3.964f, 8.537f)
                lineTo(3.879f, 8.589f)
                curveTo(3.896f, 8.617f, 3.925f, 8.64f, 3.955f, 8.659f)
                curveTo(3.986f, 8.679f, 4.025f, 8.698f, 4.067f, 8.715f)
                curveTo(4.152f, 8.751f, 4.257f, 8.784f, 4.366f, 8.814f)
                curveTo(4.585f, 8.872f, 4.822f, 8.917f, 4.946f, 8.934f)
                lineTo(4.96f, 8.835f)
                close()
                moveTo(6.801f, 8.772f)
                curveTo(6.383f, 8.795f, 5.972f, 8.818f, 5.641f, 8.831f)
                curveTo(5.307f, 8.845f, 5.059f, 8.849f, 4.96f, 8.835f)
                lineTo(4.946f, 8.934f)
                curveTo(5.056f, 8.949f, 5.315f, 8.945f, 5.645f, 8.931f)
                curveTo(5.977f, 8.918f, 6.388f, 8.895f, 6.807f, 8.871f)
                lineTo(6.801f, 8.772f)
                close()
                moveTo(7.217f, 8.749f)
                curveTo(7.079f, 8.756f, 6.94f, 8.764f, 6.801f, 8.772f)
                lineTo(6.807f, 8.871f)
                curveTo(6.945f, 8.864f, 7.085f, 8.856f, 7.222f, 8.848f)
                lineTo(7.217f, 8.749f)
                close()
                moveTo(9.586f, 8.815f)
                curveTo(9.027f, 8.778f, 7.953f, 8.709f, 7.217f, 8.749f)
                lineTo(7.222f, 8.848f)
                curveTo(7.951f, 8.809f, 9.018f, 8.878f, 9.579f, 8.914f)
                lineTo(9.586f, 8.815f)
                close()
                moveTo(9.937f, 8.835f)
                curveTo(9.893f, 8.835f, 9.768f, 8.827f, 9.586f, 8.815f)
                lineTo(9.579f, 8.914f)
                curveTo(9.759f, 8.926f, 9.889f, 8.935f, 9.937f, 8.935f)
                verticalLineTo(8.835f)
                close()
                moveTo(10.118f, 9.07f)
                curveTo(10.124f, 9.042f, 10.131f, 9.013f, 10.133f, 8.988f)
                curveTo(10.136f, 8.962f, 10.135f, 8.932f, 10.121f, 8.905f)
                curveTo(10.106f, 8.876f, 10.08f, 8.858f, 10.049f, 8.848f)
                curveTo(10.019f, 8.838f, 9.981f, 8.835f, 9.937f, 8.835f)
                verticalLineTo(8.935f)
                curveTo(9.978f, 8.935f, 10.003f, 8.938f, 10.018f, 8.943f)
                curveTo(10.025f, 8.945f, 10.029f, 8.948f, 10.031f, 8.949f)
                curveTo(10.032f, 8.95f, 10.032f, 8.951f, 10.033f, 8.951f)
                curveTo(10.033f, 8.953f, 10.036f, 8.959f, 10.034f, 8.978f)
                curveTo(10.032f, 8.996f, 10.027f, 9.018f, 10.02f, 9.048f)
                lineTo(10.118f, 9.07f)
                close()
                moveTo(10.111f, 9.101f)
                curveTo(10.113f, 9.09f, 10.116f, 9.08f, 10.118f, 9.07f)
                lineTo(10.02f, 9.048f)
                curveTo(10.018f, 9.058f, 10.016f, 9.069f, 10.014f, 9.08f)
                lineTo(10.111f, 9.101f)
                close()
                moveTo(10.274f, 9.504f)
                curveTo(10.275f, 9.505f, 10.271f, 9.503f, 10.262f, 9.493f)
                curveTo(10.253f, 9.485f, 10.244f, 9.473f, 10.233f, 9.457f)
                curveTo(10.212f, 9.427f, 10.188f, 9.386f, 10.168f, 9.341f)
                curveTo(10.147f, 9.296f, 10.13f, 9.248f, 10.119f, 9.205f)
                curveTo(10.108f, 9.16f, 10.106f, 9.124f, 10.111f, 9.101f)
                lineTo(10.014f, 9.08f)
                curveTo(10.004f, 9.125f, 10.01f, 9.178f, 10.022f, 9.228f)
                curveTo(10.034f, 9.279f, 10.054f, 9.333f, 10.077f, 9.382f)
                curveTo(10.099f, 9.432f, 10.125f, 9.478f, 10.151f, 9.515f)
                curveTo(10.164f, 9.533f, 10.177f, 9.55f, 10.19f, 9.563f)
                curveTo(10.202f, 9.576f, 10.218f, 9.589f, 10.236f, 9.597f)
                lineTo(10.274f, 9.504f)
                close()
                moveTo(11.084f, 9.398f)
                curveTo(10.953f, 9.448f, 10.763f, 9.481f, 10.596f, 9.498f)
                curveTo(10.512f, 9.506f, 10.436f, 9.51f, 10.377f, 9.51f)
                curveTo(10.347f, 9.511f, 10.322f, 9.51f, 10.303f, 9.508f)
                curveTo(10.294f, 9.507f, 10.286f, 9.507f, 10.281f, 9.506f)
                curveTo(10.275f, 9.505f, 10.273f, 9.504f, 10.274f, 9.504f)
                lineTo(10.236f, 9.597f)
                curveTo(10.252f, 9.603f, 10.274f, 9.606f, 10.295f, 9.608f)
                curveTo(10.318f, 9.61f, 10.346f, 9.611f, 10.377f, 9.61f)
                curveTo(10.44f, 9.61f, 10.52f, 9.606f, 10.606f, 9.597f)
                curveTo(10.776f, 9.58f, 10.976f, 9.546f, 11.12f, 9.491f)
                lineTo(11.084f, 9.398f)
                close()
                moveTo(11.338f, 9.365f)
                curveTo(11.328f, 9.361f, 11.316f, 9.355f, 11.3f, 9.351f)
                curveTo(11.284f, 9.347f, 11.267f, 9.346f, 11.248f, 9.348f)
                curveTo(11.211f, 9.352f, 11.161f, 9.368f, 11.084f, 9.398f)
                lineTo(11.12f, 9.491f)
                curveTo(11.198f, 9.461f, 11.236f, 9.45f, 11.258f, 9.448f)
                curveTo(11.268f, 9.447f, 11.273f, 9.447f, 11.276f, 9.448f)
                curveTo(11.281f, 9.449f, 11.286f, 9.451f, 11.297f, 9.456f)
                lineTo(11.338f, 9.365f)
                close()
                moveTo(11.517f, 9.394f)
                curveTo(11.457f, 9.394f, 11.418f, 9.39f, 11.392f, 9.384f)
                curveTo(11.367f, 9.378f, 11.352f, 9.372f, 11.338f, 9.365f)
                lineTo(11.297f, 9.456f)
                curveTo(11.313f, 9.464f, 11.335f, 9.474f, 11.371f, 9.482f)
                curveTo(11.406f, 9.489f, 11.452f, 9.494f, 11.517f, 9.494f)
                verticalLineTo(9.394f)
                close()
                moveTo(11.673f, 8.981f)
                curveTo(11.669f, 9.078f, 11.665f, 9.187f, 11.64f, 9.271f)
                curveTo(11.628f, 9.313f, 11.612f, 9.344f, 11.592f, 9.364f)
                curveTo(11.574f, 9.383f, 11.551f, 9.394f, 11.517f, 9.394f)
                verticalLineTo(9.494f)
                curveTo(11.578f, 9.494f, 11.627f, 9.472f, 11.664f, 9.434f)
                curveTo(11.699f, 9.397f, 11.722f, 9.349f, 11.736f, 9.299f)
                curveTo(11.765f, 9.201f, 11.769f, 9.079f, 11.773f, 8.985f)
                lineTo(11.673f, 8.981f)
                close()
                moveTo(11.76f, 8.749f)
                curveTo(11.725f, 8.749f, 11.706f, 8.773f, 11.697f, 8.79f)
                curveTo(11.689f, 8.807f, 11.685f, 8.826f, 11.682f, 8.844f)
                curveTo(11.676f, 8.881f, 11.675f, 8.93f, 11.673f, 8.981f)
                lineTo(11.773f, 8.985f)
                curveTo(11.775f, 8.932f, 11.776f, 8.889f, 11.781f, 8.859f)
                curveTo(11.783f, 8.844f, 11.786f, 8.837f, 11.786f, 8.835f)
                curveTo(11.787f, 8.834f, 11.78f, 8.849f, 11.76f, 8.849f)
                verticalLineTo(8.749f)
                close()
                moveTo(11.929f, 8.976f)
                curveTo(11.908f, 8.928f, 11.885f, 8.877f, 11.862f, 8.837f)
                curveTo(11.851f, 8.817f, 11.839f, 8.798f, 11.825f, 8.783f)
                curveTo(11.814f, 8.77f, 11.792f, 8.749f, 11.76f, 8.749f)
                verticalLineTo(8.849f)
                curveTo(11.745f, 8.849f, 11.742f, 8.839f, 11.75f, 8.849f)
                curveTo(11.757f, 8.856f, 11.765f, 8.869f, 11.775f, 8.886f)
                curveTo(11.795f, 8.921f, 11.816f, 8.968f, 11.838f, 9.017f)
                lineTo(11.929f, 8.976f)
                close()
                moveTo(11.959f, 9.003f)
                curveTo(11.959f, 9.036f, 11.958f, 9.062f, 11.956f, 9.082f)
                curveTo(11.955f, 9.102f, 11.952f, 9.115f, 11.95f, 9.122f)
                curveTo(11.949f, 9.126f, 11.949f, 9.127f, 11.949f, 9.126f)
                curveTo(11.95f, 9.125f, 11.953f, 9.12f, 11.96f, 9.116f)
                curveTo(11.968f, 9.11f, 11.978f, 9.108f, 11.987f, 9.11f)
                curveTo(11.995f, 9.111f, 12f, 9.114f, 12.001f, 9.115f)
                curveTo(12.002f, 9.116f, 12.002f, 9.116f, 12f, 9.114f)
                curveTo(11.999f, 9.112f, 11.997f, 9.11f, 11.994f, 9.106f)
                curveTo(11.989f, 9.098f, 11.983f, 9.087f, 11.976f, 9.074f)
                curveTo(11.962f, 9.047f, 11.946f, 9.012f, 11.929f, 8.976f)
                lineTo(11.838f, 9.017f)
                curveTo(11.855f, 9.053f, 11.871f, 9.09f, 11.887f, 9.12f)
                curveTo(11.895f, 9.135f, 11.903f, 9.149f, 11.911f, 9.161f)
                curveTo(11.918f, 9.172f, 11.928f, 9.186f, 11.941f, 9.195f)
                curveTo(11.948f, 9.2f, 11.958f, 9.206f, 11.971f, 9.208f)
                curveTo(11.986f, 9.211f, 12.001f, 9.208f, 12.014f, 9.2f)
                curveTo(12.035f, 9.186f, 12.043f, 9.163f, 12.047f, 9.149f)
                curveTo(12.055f, 9.119f, 12.059f, 9.07f, 12.059f, 9.003f)
                horizontalLineTo(11.959f)
                close()
                moveTo(11.325f, 8.066f)
                curveTo(11.331f, 8.065f, 11.346f, 8.064f, 11.373f, 8.075f)
                curveTo(11.398f, 8.085f, 11.429f, 8.103f, 11.463f, 8.129f)
                curveTo(11.532f, 8.181f, 11.611f, 8.261f, 11.685f, 8.356f)
                curveTo(11.835f, 8.549f, 11.959f, 8.796f, 11.959f, 9.003f)
                horizontalLineTo(12.059f)
                curveTo(12.059f, 8.763f, 11.92f, 8.494f, 11.764f, 8.295f)
                curveTo(11.686f, 8.194f, 11.601f, 8.108f, 11.523f, 8.049f)
                curveTo(11.484f, 8.02f, 11.446f, 7.997f, 11.41f, 7.982f)
                curveTo(11.375f, 7.968f, 11.335f, 7.96f, 11.299f, 7.97f)
                lineTo(11.325f, 8.066f)
                close()
                moveTo(10.85f, 8.039f)
                curveTo(10.917f, 8.052f, 11.002f, 8.067f, 11.086f, 8.075f)
                curveTo(11.168f, 8.084f, 11.256f, 8.085f, 11.325f, 8.066f)
                lineTo(11.299f, 7.97f)
                curveTo(11.248f, 7.984f, 11.176f, 7.984f, 11.095f, 7.976f)
                curveTo(11.017f, 7.968f, 10.935f, 7.953f, 10.868f, 7.941f)
                lineTo(10.85f, 8.039f)
                close()
                moveTo(10.732f, 8.021f)
                curveTo(10.74f, 8.021f, 10.753f, 8.023f, 10.775f, 8.026f)
                curveTo(10.796f, 8.029f, 10.821f, 8.034f, 10.85f, 8.039f)
                lineTo(10.868f, 7.941f)
                curveTo(10.839f, 7.936f, 10.813f, 7.931f, 10.79f, 7.927f)
                curveTo(10.769f, 7.924f, 10.748f, 7.921f, 10.732f, 7.921f)
                verticalLineTo(8.021f)
                close()
                moveTo(10.7f, 7.906f)
                curveTo(10.694f, 7.91f, 10.688f, 7.915f, 10.683f, 7.92f)
                curveTo(10.681f, 7.923f, 10.677f, 7.926f, 10.674f, 7.93f)
                curveTo(10.671f, 7.933f, 10.665f, 7.941f, 10.662f, 7.953f)
                curveTo(10.659f, 7.967f, 10.66f, 7.985f, 10.673f, 8f)
                curveTo(10.683f, 8.012f, 10.695f, 8.016f, 10.7f, 8.018f)
                curveTo(10.711f, 8.021f, 10.724f, 8.021f, 10.732f, 8.021f)
                verticalLineTo(7.921f)
                curveTo(10.724f, 7.921f, 10.725f, 7.921f, 10.729f, 7.922f)
                curveTo(10.731f, 7.922f, 10.741f, 7.926f, 10.75f, 7.936f)
                curveTo(10.754f, 7.941f, 10.758f, 7.949f, 10.76f, 7.957f)
                curveTo(10.761f, 7.965f, 10.76f, 7.972f, 10.759f, 7.977f)
                curveTo(10.757f, 7.987f, 10.752f, 7.992f, 10.752f, 7.993f)
                curveTo(10.751f, 7.994f, 10.75f, 7.994f, 10.751f, 7.994f)
                curveTo(10.753f, 7.992f, 10.756f, 7.989f, 10.762f, 7.984f)
                lineTo(10.7f, 7.906f)
                close()
                moveTo(10.76f, 7.821f)
                curveTo(10.76f, 7.836f, 10.754f, 7.851f, 10.742f, 7.866f)
                curveTo(10.73f, 7.882f, 10.715f, 7.894f, 10.7f, 7.906f)
                lineTo(10.762f, 7.984f)
                curveTo(10.777f, 7.973f, 10.801f, 7.953f, 10.821f, 7.928f)
                curveTo(10.841f, 7.901f, 10.86f, 7.866f, 10.86f, 7.821f)
                horizontalLineTo(10.76f)
                close()
                moveTo(10.623f, 7.748f)
                curveTo(10.664f, 7.748f, 10.701f, 7.752f, 10.727f, 7.764f)
                curveTo(10.739f, 7.77f, 10.746f, 7.776f, 10.751f, 7.784f)
                curveTo(10.756f, 7.791f, 10.76f, 7.802f, 10.76f, 7.821f)
                horizontalLineTo(10.86f)
                curveTo(10.86f, 7.786f, 10.852f, 7.755f, 10.835f, 7.729f)
                curveTo(10.818f, 7.703f, 10.794f, 7.686f, 10.77f, 7.674f)
                curveTo(10.723f, 7.652f, 10.667f, 7.648f, 10.623f, 7.648f)
                verticalLineTo(7.748f)
                close()
                moveTo(10.543f, 7.821f)
                curveTo(10.543f, 7.791f, 10.57f, 7.748f, 10.623f, 7.748f)
                verticalLineTo(7.648f)
                curveTo(10.506f, 7.648f, 10.443f, 7.744f, 10.443f, 7.821f)
                horizontalLineTo(10.543f)
                close()
                moveTo(10.557f, 7.928f)
                curveTo(10.589f, 7.89f, 10.589f, 7.89f, 10.589f, 7.89f)
                curveTo(10.589f, 7.89f, 10.589f, 7.89f, 10.589f, 7.89f)
                curveTo(10.589f, 7.89f, 10.589f, 7.89f, 10.589f, 7.89f)
                curveTo(10.589f, 7.89f, 10.589f, 7.89f, 10.589f, 7.89f)
                curveTo(10.589f, 7.89f, 10.589f, 7.89f, 10.589f, 7.89f)
                curveTo(10.589f, 7.89f, 10.589f, 7.89f, 10.589f, 7.89f)
                curveTo(10.589f, 7.889f, 10.588f, 7.889f, 10.587f, 7.888f)
                curveTo(10.586f, 7.887f, 10.584f, 7.885f, 10.582f, 7.883f)
                curveTo(10.577f, 7.878f, 10.57f, 7.871f, 10.564f, 7.863f)
                curveTo(10.549f, 7.845f, 10.543f, 7.829f, 10.543f, 7.821f)
                horizontalLineTo(10.443f)
                curveTo(10.443f, 7.865f, 10.468f, 7.903f, 10.486f, 7.925f)
                curveTo(10.495f, 7.937f, 10.505f, 7.947f, 10.512f, 7.954f)
                curveTo(10.515f, 7.958f, 10.518f, 7.96f, 10.52f, 7.962f)
                curveTo(10.521f, 7.963f, 10.522f, 7.964f, 10.523f, 7.965f)
                curveTo(10.523f, 7.965f, 10.524f, 7.965f, 10.524f, 7.966f)
                curveTo(10.524f, 7.966f, 10.524f, 7.966f, 10.524f, 7.966f)
                curveTo(10.524f, 7.966f, 10.524f, 7.966f, 10.524f, 7.966f)
                curveTo(10.524f, 7.966f, 10.524f, 7.966f, 10.524f, 7.966f)
                curveTo(10.524f, 7.966f, 10.524f, 7.966f, 10.524f, 7.966f)
                curveTo(10.524f, 7.966f, 10.524f, 7.966f, 10.557f, 7.928f)
                close()
                moveTo(10.369f, 7.976f)
                curveTo(10.475f, 7.977f, 10.543f, 7.978f, 10.557f, 7.978f)
                verticalLineTo(7.878f)
                curveTo(10.544f, 7.878f, 10.477f, 7.877f, 10.37f, 7.876f)
                lineTo(10.369f, 7.976f)
                close()
                moveTo(6.973f, 7.977f)
                curveTo(7.057f, 7.967f, 7.268f, 7.961f, 7.55f, 7.958f)
                curveTo(7.831f, 7.955f, 8.181f, 7.955f, 8.541f, 7.957f)
                curveTo(9.261f, 7.961f, 10.023f, 7.971f, 10.369f, 7.976f)
                lineTo(10.37f, 7.876f)
                curveTo(10.024f, 7.871f, 9.262f, 7.861f, 8.541f, 7.857f)
                curveTo(8.181f, 7.855f, 7.831f, 7.855f, 7.549f, 7.858f)
                curveTo(7.269f, 7.861f, 7.052f, 7.867f, 6.961f, 7.878f)
                lineTo(6.973f, 7.977f)
                close()
                moveTo(10.578f, 8.656f)
                curveTo(10.517f, 8.731f, 10.473f, 8.776f, 10.446f, 8.801f)
                curveTo(10.433f, 8.814f, 10.423f, 8.822f, 10.417f, 8.826f)
                curveTo(10.415f, 8.828f, 10.413f, 8.829f, 10.412f, 8.83f)
                curveTo(10.411f, 8.83f, 10.411f, 8.831f, 10.411f, 8.831f)
                curveTo(10.411f, 8.831f, 10.411f, 8.831f, 10.411f, 8.831f)
                curveTo(10.411f, 8.831f, 10.41f, 8.831f, 10.41f, 8.832f)
                curveTo(10.41f, 8.832f, 10.409f, 8.832f, 10.408f, 8.833f)
                curveTo(10.407f, 8.833f, 10.405f, 8.835f, 10.403f, 8.837f)
                curveTo(10.402f, 8.838f, 10.399f, 8.842f, 10.397f, 8.844f)
                curveTo(10.393f, 8.851f, 10.388f, 8.879f, 10.394f, 8.898f)
                lineTo(10.481f, 8.848f)
                curveTo(10.487f, 8.867f, 10.482f, 8.895f, 10.478f, 8.902f)
                curveTo(10.476f, 8.905f, 10.473f, 8.908f, 10.472f, 8.91f)
                curveTo(10.47f, 8.912f, 10.468f, 8.913f, 10.467f, 8.913f)
                curveTo(10.466f, 8.914f, 10.465f, 8.915f, 10.465f, 8.915f)
                curveTo(10.465f, 8.915f, 10.465f, 8.915f, 10.465f, 8.915f)
                curveTo(10.465f, 8.915f, 10.465f, 8.915f, 10.465f, 8.915f)
                curveTo(10.465f, 8.915f, 10.465f, 8.915f, 10.465f, 8.915f)
                curveTo(10.466f, 8.914f, 10.467f, 8.914f, 10.468f, 8.913f)
                curveTo(10.471f, 8.911f, 10.474f, 8.909f, 10.478f, 8.905f)
                curveTo(10.487f, 8.899f, 10.499f, 8.889f, 10.514f, 8.875f)
                curveTo(10.545f, 8.846f, 10.592f, 8.797f, 10.656f, 8.719f)
                lineTo(10.578f, 8.656f)
                close()
                moveTo(10.893f, 8.594f)
                curveTo(10.881f, 8.581f, 10.865f, 8.563f, 10.847f, 8.549f)
                curveTo(10.827f, 8.534f, 10.801f, 8.521f, 10.769f, 8.522f)
                curveTo(10.737f, 8.522f, 10.706f, 8.535f, 10.676f, 8.557f)
                curveTo(10.646f, 8.579f, 10.614f, 8.611f, 10.578f, 8.656f)
                lineTo(10.656f, 8.719f)
                curveTo(10.689f, 8.678f, 10.715f, 8.653f, 10.735f, 8.638f)
                curveTo(10.755f, 8.624f, 10.766f, 8.622f, 10.77f, 8.622f)
                curveTo(10.774f, 8.622f, 10.778f, 8.623f, 10.787f, 8.629f)
                curveTo(10.796f, 8.636f, 10.805f, 8.646f, 10.819f, 8.661f)
                lineTo(10.893f, 8.594f)
                close()
                moveTo(10.95f, 8.637f)
                curveTo(10.943f, 8.637f, 10.937f, 8.635f, 10.927f, 8.628f)
                curveTo(10.917f, 8.621f, 10.907f, 8.61f, 10.893f, 8.594f)
                lineTo(10.819f, 8.661f)
                curveTo(10.842f, 8.686f, 10.883f, 8.737f, 10.95f, 8.737f)
                verticalLineTo(8.637f)
                close()
                moveTo(11.356f, 8.735f)
                curveTo(11.296f, 8.684f, 11.222f, 8.66f, 11.151f, 8.648f)
                curveTo(11.08f, 8.637f, 11.008f, 8.637f, 10.95f, 8.637f)
                verticalLineTo(8.737f)
                curveTo(11.009f, 8.737f, 11.073f, 8.737f, 11.135f, 8.747f)
                curveTo(11.197f, 8.757f, 11.251f, 8.776f, 11.292f, 8.811f)
                lineTo(11.356f, 8.735f)
                close()
                moveTo(11.123f, 9.027f)
                curveTo(11.15f, 9.027f, 11.185f, 9.016f, 11.216f, 9.003f)
                curveTo(11.249f, 8.99f, 11.286f, 8.97f, 11.317f, 8.947f)
                curveTo(11.346f, 8.925f, 11.378f, 8.896f, 11.392f, 8.859f)
                curveTo(11.399f, 8.839f, 11.402f, 8.817f, 11.396f, 8.793f)
                curveTo(11.389f, 8.77f, 11.375f, 8.751f, 11.356f, 8.735f)
                lineTo(11.292f, 8.811f)
                curveTo(11.295f, 8.814f, 11.297f, 8.816f, 11.298f, 8.818f)
                curveTo(11.299f, 8.818f, 11.299f, 8.819f, 11.299f, 8.819f)
                curveTo(11.299f, 8.819f, 11.299f, 8.82f, 11.299f, 8.82f)
                curveTo(11.299f, 8.82f, 11.299f, 8.82f, 11.299f, 8.82f)
                curveTo(11.299f, 8.82f, 11.299f, 8.82f, 11.299f, 8.82f)
                curveTo(11.299f, 8.82f, 11.299f, 8.82f, 11.299f, 8.82f)
                curveTo(11.299f, 8.82f, 11.299f, 8.82f, 11.299f, 8.82f)
                curveTo(11.299f, 8.82f, 11.299f, 8.821f, 11.298f, 8.823f)
                curveTo(11.295f, 8.833f, 11.282f, 8.849f, 11.257f, 8.867f)
                curveTo(11.234f, 8.884f, 11.205f, 8.9f, 11.178f, 8.911f)
                curveTo(11.149f, 8.923f, 11.13f, 8.927f, 11.123f, 8.927f)
                verticalLineTo(9.027f)
                close()
                moveTo(11.006f, 8.973f)
                curveTo(11.029f, 8.992f, 11.068f, 9.027f, 11.123f, 9.027f)
                verticalLineTo(8.927f)
                curveTo(11.11f, 8.927f, 11.099f, 8.92f, 11.071f, 8.896f)
                lineTo(11.006f, 8.973f)
                close()
                moveTo(10.951f, 8.941f)
                curveTo(10.966f, 8.941f, 10.978f, 8.949f, 11.006f, 8.973f)
                lineTo(11.071f, 8.896f)
                curveTo(11.048f, 8.877f, 11.008f, 8.841f, 10.951f, 8.841f)
                verticalLineTo(8.941f)
                close()
                moveTo(10.878f, 8.984f)
                curveTo(10.893f, 8.971f, 10.906f, 8.96f, 10.92f, 8.952f)
                curveTo(10.933f, 8.944f, 10.943f, 8.941f, 10.951f, 8.941f)
                verticalLineTo(8.841f)
                curveTo(10.918f, 8.841f, 10.89f, 8.853f, 10.868f, 8.866f)
                curveTo(10.846f, 8.88f, 10.827f, 8.896f, 10.813f, 8.908f)
                lineTo(10.878f, 8.984f)
                close()
                moveTo(10.797f, 9.027f)
                curveTo(10.819f, 9.027f, 10.838f, 9.016f, 10.847f, 9.009f)
                curveTo(10.858f, 9.001f, 10.869f, 8.992f, 10.878f, 8.984f)
                lineTo(10.813f, 8.908f)
                curveTo(10.803f, 8.917f, 10.796f, 8.923f, 10.791f, 8.927f)
                curveTo(10.788f, 8.928f, 10.787f, 8.929f, 10.788f, 8.928f)
                curveTo(10.788f, 8.928f, 10.791f, 8.927f, 10.797f, 8.927f)
                verticalLineTo(9.027f)
                close()
                moveTo(10.701f, 8.987f)
                curveTo(10.717f, 8.996f, 10.733f, 9.005f, 10.747f, 9.012f)
                curveTo(10.754f, 9.015f, 10.761f, 9.019f, 10.768f, 9.021f)
                curveTo(10.774f, 9.024f, 10.785f, 9.027f, 10.797f, 9.027f)
                verticalLineTo(8.927f)
                curveTo(10.803f, 8.927f, 10.806f, 8.928f, 10.803f, 8.927f)
                curveTo(10.8f, 8.927f, 10.797f, 8.925f, 10.792f, 8.922f)
                curveTo(10.781f, 8.917f, 10.768f, 8.909f, 10.75f, 8.9f)
                lineTo(10.701f, 8.987f)
                close()
                moveTo(10.507f, 8.909f)
                curveTo(10.532f, 8.909f, 10.564f, 8.918f, 10.6f, 8.934f)
                curveTo(10.635f, 8.949f, 10.67f, 8.969f, 10.701f, 8.987f)
                lineTo(10.75f, 8.9f)
                curveTo(10.72f, 8.882f, 10.681f, 8.86f, 10.64f, 8.842f)
                curveTo(10.6f, 8.824f, 10.553f, 8.809f, 10.507f, 8.809f)
                verticalLineTo(8.909f)
                close()
                moveTo(10.394f, 8.898f)
                curveTo(10.404f, 8.91f, 10.425f, 8.922f, 10.434f, 8.923f)
                curveTo(10.438f, 8.923f, 10.445f, 8.923f, 10.447f, 8.922f)
                curveTo(10.451f, 8.921f, 10.454f, 8.92f, 10.455f, 8.92f)
                curveTo(10.457f, 8.919f, 10.458f, 8.919f, 10.458f, 8.918f)
                curveTo(10.459f, 8.918f, 10.46f, 8.918f, 10.46f, 8.918f)
                curveTo(10.46f, 8.918f, 10.461f, 8.917f, 10.461f, 8.917f)
                curveTo(10.461f, 8.917f, 10.461f, 8.917f, 10.461f, 8.917f)
                curveTo(10.461f, 8.917f, 10.461f, 8.917f, 10.461f, 8.917f)
                curveTo(10.461f, 8.917f, 10.462f, 8.917f, 10.462f, 8.917f)
                curveTo(10.464f, 8.916f, 10.466f, 8.915f, 10.47f, 8.914f)
                curveTo(10.478f, 8.912f, 10.49f, 8.909f, 10.507f, 8.909f)
                verticalLineTo(8.809f)
                curveTo(10.479f, 8.809f, 10.457f, 8.813f, 10.441f, 8.818f)
                curveTo(10.433f, 8.821f, 10.427f, 8.823f, 10.422f, 8.825f)
                curveTo(10.42f, 8.826f, 10.418f, 8.827f, 10.416f, 8.828f)
                curveTo(10.416f, 8.828f, 10.415f, 8.828f, 10.415f, 8.829f)
                curveTo(10.415f, 8.829f, 10.415f, 8.829f, 10.415f, 8.828f)
                curveTo(10.415f, 8.828f, 10.416f, 8.828f, 10.417f, 8.828f)
                curveTo(10.417f, 8.828f, 10.418f, 8.827f, 10.42f, 8.826f)
                curveTo(10.421f, 8.826f, 10.424f, 8.825f, 10.428f, 8.824f)
                curveTo(10.43f, 8.824f, 10.437f, 8.823f, 10.441f, 8.823f)
                curveTo(10.45f, 8.825f, 10.471f, 8.836f, 10.481f, 8.848f)
                lineTo(10.394f, 8.898f)
                close()
            }
            path(
                stroke = SolidColor(Color.White),
                strokeLineWidth = 0.5f
            ) {
                moveTo(13.116f, 2.373f)
                curveTo(13.116f, 2.373f, 13.923f, 6f, 13.116f, 6f)
                curveTo(12.309f, 6f, 12.309f, 5.684f, 12.309f, 5.684f)
                curveTo(12.309f, 5.684f, 13.195f, 6.091f, 12.95f, 5.025f)
                curveTo(12.705f, 3.96f, 12.476f, 4.693f, 12.476f, 3.756f)
                curveTo(12.476f, 2.819f, 12.309f, 2.19f, 12.309f, 2.669f)
                curveTo(12.309f, 3.149f, 12.198f, 6.044f, 11.76f, 5.451f)
                curveTo(11.322f, 4.859f, 11.429f, 3.025f, 11.429f, 2.847f)
            }
        }
    }.build()
}

@Preview
@Composable
private fun SaudiArabiaPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Small.SaudiArabia,
            contentDescription = "Saudi Arabia Flag"
        )
    }
}
